<template>
  <v-app>
    <v-app-bar
      app
      dense
      color="white"
      elevation="0"
    >
      <v-toolbar-title class="title">
        <router-link to="/" class="black--text">
          Frogwares API
        </router-link>
      </v-toolbar-title>
      <v-spacer/>
      <v-btn to="/images" text>
        Images
      </v-btn>
      <v-btn
        text
        color="black"
        @click="logout"
      >
        <v-icon>mdi-logout</v-icon>
      </v-btn>
    </v-app-bar>
    <v-content class="white">
      <router-view/>
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  data: () => ({}),
  methods: {
    async logout() {
      localStorage.clear()
      await this.$store.dispatch('logout')
      this.$nextTick(() => {
        this.$router.push('/login')
      })
    }
  },
};
</script>

<style scoped>
  .title a {
    text-decoration: none;
  }
</style>